import { render, staticRenderFns } from "./HighTalent.vue?vue&type=template&id=2205dcea&scoped=true&"
import script from "./HighTalent.vue?vue&type=script&lang=js&"
export * from "./HighTalent.vue?vue&type=script&lang=js&"
import style0 from "./HighTalent.vue?vue&type=style&index=0&id=2205dcea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205dcea",
  null
  
)

export default component.exports